import { EntityState, createEntityAdapter } from '@ngrx/entity';
import { ErrorDetail, UserDomain } from '../../synaps-media.types';

export const domainFeatureKey = 'domains';

export const domainsAdapter = createEntityAdapter<UserDomain>({
  selectId: (domain: UserDomain) => {
    // Ensure we always have a valid ID, fallback to domain name if id is not available
    // Convert id to string to ensure consistent type
    return domain.id ? String(domain.id) : domain.domain;
  },
  sortComparer: (a: UserDomain, b: UserDomain) => a.domain.localeCompare(b.domain) // Sort alphabetically by domain name
});

export interface DomainsState extends EntityState<UserDomain> {
  loading: boolean;
  loadingCreate: boolean;
  error: ErrorDetail | null;
  selectedDomainId: number | null;
}

export const initialDomainsState: DomainsState = domainsAdapter.getInitialState({
  loading: false,
  loadingCreate: false,
  error: null,
  selectedDomainId: null,
});
